/*
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
*/
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '@windriver/authentication';
import { ApiResponse } from '@models';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';

// Calls endpoints for refreshing/syncing users' back end representation
@Injectable({
  providedIn: 'root'
})
export class RefreshService {
  private apiBackendBaseUrl: string;

  readonly httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(private http: HttpClient, private snackBar: MatSnackBar, private configService: ConfigService) {
    this.configService.configState.subscribe((config: any) => {
      // this.apiBackendBaseUrl = config.apiUrl;
      if (config) {
        this.apiBackendBaseUrl = config.apiUrl;
      }
    });
  }

  public RefreshEverything(username: string): Observable<any> {
    // Refresh entitlements first.
    return this.RefreshEntitlements(username).pipe(
      // catchError(error => {
      //   return throwError(error);
      // }),
      finalize(() => {
        // After success or failure of refreshing entitlements, synchronize tozny
        this.SyncTools(username).subscribe(() => console.log('tools synchronized'));
      })
    );
  }

  public SyncTools(username: string): Observable<ApiResponse> {
    return this.http.post<any>(this.apiBackendBaseUrl + `/v1/sync/${username}/tools`, this.httpOptions).pipe(
      catchError((error) => {
        console.error(`Error synchronizing tools: ${JSON.stringify(error)}`);
        this.snackBar.open('The Tool syncing operation was not successful', 'Close', { duration: 1000 });
        return throwError(error);
      })
    );
  }

  public RefreshEntitlements(username: string): Observable<ApiResponse> {
    return this.http.post(this.apiBackendBaseUrl + `/v1/entitlement/${username}/refresh`, this.httpOptions).pipe(
      catchError((error) => {
        console.error(`Error refreshing entitlements: ${JSON.stringify(error)}`);
        this.snackBar.open('The Entitlement refresh operation was not successful', 'Close');
        return throwError(error);
      })
    );
  }
}
